import { render } from "./PosVe.vue?vue&type=template&id=da8c5d70&scoped=true"
import script from "./PosVe.vue?vue&type=script&lang=js"
export * from "./PosVe.vue?vue&type=script&lang=js"

import "./PosVe.vue?vue&type=style&index=0&id=da8c5d70&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8c5d70"]])

export default __exports__